import { MdOutlineFileDownload } from "react-icons/md";
import { FC } from "react";
import axios from "axios";
import config from "../../utils/config";

type Props = {
  eventId: string;
};

export const AdminParticipantsExportButton: FC<Props> = ({ eventId }) => {
const handleDownload = async () => {
  try {
    const token = localStorage.getItem("token");
    const url = `${config.baseURL}/Events/${eventId}/excel-export`;

    const response = await axios.get(url, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    // DEBUG: Log all headers to see what we're getting
    console.log("All response headers:", response.headers);

    const blob = new Blob([response.data], {
      type: response.headers["content-type"],
    });
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;

    // Enhanced debugging for Content-Disposition
    const disposition = response.headers["content-disposition"] || response.headers["Content-Disposition"];
    console.log("Content-Disposition header:", disposition);

    let fileName = `registrations_${eventId}.xlsx`;

    if (disposition) {
      // First try to parse filename*= (RFC 5987 - supports UTF-8 encoding)
      const encodedMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
      console.log("Encoded filename match:", encodedMatch);

      if (encodedMatch?.[1]) {
        fileName = decodeURIComponent(encodedMatch[1]);
        console.log("Using encoded filename:", fileName);
      } else {
        // Fallback to standard filename= (with or without quotes)
        const standardMatch = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
        console.log("Standard filename match:", standardMatch);

        if (standardMatch?.[1]) {
          fileName = standardMatch[1].replace(/['"]/g, '');
          console.log("Using standard filename:", fileName);
        }
      }
    } else {
      console.log("No Content-Disposition header found, using default filename");
    }

    console.log("Final filename:", fileName);
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);
  } catch (err) {
    console.error("Export failed:", err);
  }
};

  return (
    <div className="flex justify-center md:justify-end w-full">
      <button
        onClick={handleDownload}
        className="px-4 py-2 bg-gray-300 rounded inline-flex items-center gap-1 hover:bg-gray-400"
      >
        <MdOutlineFileDownload size={20} /> Stáhnout seznam
      </button>
    </div>
  );
};
